import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ERROR_BOUNDARY] Uncaught render error:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#04050A',
            color: '#F4F6FF',
            fontFamily: "var(--gph-font-sans)",
            padding: '24px',
            textAlign: 'center'
          }}
        >
          <div style={{ fontSize: '46px', marginBottom: '14px', color: '#FF9A1F' }}>⚠</div>
          <h1 style={{ fontSize: '19px', fontWeight: 900, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.18em' }}>
            Erro inesperado
          </h1>
          <p style={{ fontSize: '13px', color: '#B7BCDA', maxWidth: '320px', marginBottom: '16px' }}>
            Algo deu errado. O app foi interrompido para evitar inconsistência de dados.
          </p>
          {this.state.error && (
            <div
              style={{
                background: 'rgba(14, 19, 36, 0.94)',
                border: '1px solid rgba(255, 74, 94, 0.5)',
                padding: '12px',
                borderRadius: '10px',
                marginBottom: '24px',
                maxWidth: '380px',
                fontSize: '11px',
                color: '#FF8EA0',
                textAlign: 'left',
                fontFamily: 'monospace',
                wordBreak: 'break-word'
              }}
            >
              {this.state.error.message || String(this.state.error)}
            </div>
          )}
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '14px 32px',
              background: 'linear-gradient(180deg, #A84DFF, #5E3CFF)',
              color: '#F4F6FF',
              border: '1px solid #A63DFF',
              borderRadius: '10px',
              fontSize: '12px',
              fontWeight: 900,
              textTransform: 'uppercase',
              letterSpacing: '0.16em',
              cursor: 'pointer'
            }}
          >
            Recarregar
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
